import { useOrganization } from "@/modules/common/context/organizations/get-user-organizations.provider";
import useFetchRanks from "@/modules/common/hooks/ranks-data.hook";
import { useParams } from "react-router-dom";

const useRanksWithTarget = ({
  subDepartmentUid,
}: {
  subDepartmentUid?: string;
} = {}) => {
  const { selectedOrganization, selectedSingleOrganization } =
    useOrganization();
  const organizationFromParams = useParams();

  const organizationUId =
    organizationFromParams.uid ||
    selectedSingleOrganization?.uid ||
    selectedOrganization?.uid;

  const { ranks, ranksLoading } = useFetchRanks({
    organizationUId,
    subDepartmentUId: subDepartmentUid,
  });

  const ranksWithTarget = ranks
    .sort((a, b) => a.value - b.value)
    .filter(
      (rank) => rank.hasTarget === true || rank.hasMinimumTarget === true
    );

  return {
    ranksWithTarget,
    isLoading: ranksLoading,
  };
};

export default useRanksWithTarget;
